/*** IMPORTS FROM imports-loader ***/
var _ = require("tpl-shim/fake-lodash.js");

export default function(data) {
var __t, __p = '';
__p += '<div class="zfr-player">\n  <video class="zfr-record" muted autoplay></video>\n  <video class="zfr-playback" type="video/webm"></video>\n</div>\n\n<div class="zfr-ui-wrapper"></div>\n<div class="zfr-background"></div>\n\n<!--\nusing this strategy, we guarantee the intercom launcher does not show up, regardless of context, and with no side effects once we remove the recorder\n-->\n<style>\n#intercom-launcher {\n  display: none !important;\n}\n</style>\n';
return __p
}
